import type { MouseEvent } from 'react';

import { COLLECTION_ORDER_STATUSES } from 'models/order';

import { Badge } from '../Badge/Badge';
import type { BadgeStyleParams } from '../badgeStyle';

const DEFAULT_STYLE: BadgeStyleParams = {
  color: 'bg-surface-muted',
  activeColor: 'bg-surface-hover',
  hover: 'hover:bg-surface-hover'
};

type Props = {
  state: string;
  label?: string;
  count?: number;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: (e: MouseEvent) => void;
};

export const OrderBadge = ({
  state,
  label,
  count,
  onClick,
  className,
  selected,
  disabled
}: Props) => {
  const orderState = COLLECTION_ORDER_STATUSES.find((s) => s.id === state);
  const resolvedLabel = label || orderState?.label || '';

  return (
    <Badge
      label={resolvedLabel}
      style={orderState?.style ?? DEFAULT_STYLE}
      count={count}
      selected={selected}
      disabled={disabled}
      className={className}
      onClick={onClick}
      data-testid={`collection-status-badge-${state}`}
    />
  );
};
